// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__D3pue","imageUploader":"EGiftCard_imageUploader__Pswxi"};